<template>
  <el-dialog :title="isEdit?'编辑方案':'添加方案'"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="800px">

    <el-form :model="info" ref="schemeFm" label-width="100px" size="small">
      <el-form-item label="名称" prop="name" :rules="[{ required: true, message: '请输入方案名称', trigger: 'blur' }]">
        <el-input v-model="info.name" placeholder="请输入方案名称" size="middle"></el-input>
      </el-form-item>
      <el-form-item label="公司" prop="companyId" :rules="[{ required: true, message: '请选择公司', trigger: 'blur' }]">
        <el-select v-model="info.companyId" placeholder="请选择公司名称" :disabled="isEdit">
          <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="描述" prop="intro">
        <el-input type="textarea" rows="3" resize="none" v-model="info.intro" placeholder="请输入描述"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" rows="3" resize="none" v-model="info.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item label="选择试卷" prop="papers">
        <el-transfer
            class="transfer_box"
            v-model="paperIds"
            filterable
            :titles="['试卷列表', '已被选中']"
            :props="{key: 'id',label: 'subtitle'}"
            :data="paperList">
        </el-transfer>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="doClose()" size="small"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button type="primary" @click="save()" size="small"><i class="fa fa-save"></i> 确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {fetchList} from '@/api/manage/paper'
import {findAllList} from '@/api/manage/company'
import { editProgram, getDetail, insertPerson } from '@/api/manage/program'
import { mapGetters } from 'vuex'

export default {
  props: {
    visible: false,
    companyId: null,
    echoId: null
  },
  computed: {
    ...mapGetters(['user', 'company']),
    isEdit() {
      return this.echoId
    }
  },
  data() {
    return {
      paperList: [],
      companyList: [],
      paperIds:[],
      info: {},
      page: {
        pageNo: 1,
        pageSize: 1000
      },
    }
  },
  methods: {
    init() {
      this.getPaperList()
      this.getCompanyList()

      if (this.echoId) {
        this.getEcho()
      } else {
        this.info = {}
      }
    },
    getEcho() {
      getDetail(this.echoId).then(res => {
        this.info = res.data.result || {}
        if(this.info.papers){
          this.paperIds = this.info.papers.map(o => {return o.id})
        }
      })
    },
    getCompanyList() {
      findAllList().then(res => {
        this.companyList = res.data.result || []
      })
    },
    getPaperList() {
      let {pageNo,pageSize,param} = this.page
      fetchList({pageNo,pageSize,param}).then(res => {
        this.paperList = res.data.result.records || []
      })
    },
    filterPaper(query,item){
      console.info(query,item)
    },
    save() {
      this.info.type = 'person'
      this.info.papers = this.paperIds

      if(this.paperIds && this.paperIds.length==0){
        this.$message.warning('请至少选择一个试卷')
        return ;
      }

      this.$refs['schemeFm'].validate((valid) => {
        if (valid) {
          if(this.echoId){
            editProgram(this.info).then(res => {
              this.$message.success('保存成功')
              this.$emit('done', true)
            })
          }else{
            insertPerson(this.info).then(res => {
              this.$message.success('保存成功')
              this.$emit('done', true)
            })
          }
        }
      })
    },
    doClose() {
      this.$emit('done', false)
    }
  }

}
</script>
